





































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import * as _ from "lodash";
import Toast from "@/script/message";
import {eGameStage} from "@/common/enumData";
import store from "@/store";


@Component({
    components: {},
})
export default class DeployManage extends Vue {
    toast = new Toast();

    projectId: any = this.$route.params.id;
    version: string = "";
    number: number = 0;
    selectVersion: string = '';
    options: string[] = [];
    deployVersion: any = null;
    wait: boolean = false;

    stage: number = 0;

    stageOptions = [{name: 'Early Access', stage: eGameStage.Early}, {name: 'Complete', stage: eGameStage.Complete}];
    selectedStage = eGameStage.Early;

    // beforeRouteEnter(to, from, next){
    //     if(eGameStage.Dev === (from.params.id && store.getters.projects[from.params.id].stage)){
    //
    //         alert('배포 관리 할 게임이 없습니다. 개발 단계를 얼리억세스 이상으로 설정하여, 게임 파일을 업로드해주세요.')
    //     }else if(!from.params.id){
    //         next('/projectList')
    //     }
    //     else{
    //         next();
    //     }
    // }

    async mounted() {
        this.projectId = this.$route.params.id;
        await this.$store.dispatch("loginState");
        await this.loadVersions();


    }

    loadVersions() {
        this.$api.getProject(this.$route.params.id)
            .then((res) => {
                // this.version = res.projectVersions;
                this.$store.commit('project', res)

            })
            .finally(() => {
                const project = this.$store.getters.project(this.projectId);
                const versions = this.$store.getters.versionList(this.projectId);


                if (project.deploy_version_id) {
                    const deployVersion = _.find(
                        versions,
                        (v) => v.id === project.deploy_version_id
                    );

                    this.version = deployVersion.version;
                    this.number = deployVersion.number;
                    this.deployVersion = deployVersion;

                }

                const passedList = versions.filter((version) => {
                    return version.state === "passed";
                });

                this.options = passedList.map((version) => version.version);

                this.selectVersion = this.options[0]
            })
    }

    deploy() {
        if (!this.selectVersion) {
            return;
        }

        const versions = this.$store.getters.versions(this.projectId);
        const project = this.$store.getters.project(this.projectId);

        if (this.hasDeployFile(versions)) {
            const version = _.find(
                versions,
                (v) => v.version === this.selectVersion
            );
            const deploy_version_id = version.id;


            this.$api.updateProject({
                id: this.projectId as number,
                deploy_version_id,
            })
                .then((res) => {
                    version.state = "deploy";
                    if (this.deployVersion) {
                        const preVersion = _.find(
                            versions,
                            (v) => v.number === this.deployVersion.number
                        );
                        preVersion.state = "passed";
                        const project = this.$store.getters.project(this.projectId);
                        project.deploy_version_id = version.id;
                        console.log('project', project)
                        console.log('version', version)
                        if (project.update_version_id === version.id) {
                            project.update_version_id = null;
                        }
                    }

                    this.toast.clear();
                    this.toast.successToast(`${this.selectVersion} ${this.$t('deployed.version')}`)
                    this.$router.replace(`/${this.i18n.locale}/versionManage/${this.projectId}`);
                })
                .catch(() => {

                })
        }
        else {
            if (project.stage === eGameStage.Dev) {
                this.$modal.show('selectStageModal')
            }
        }

    }


    undeploy() {

        this.$api.updateProject({
            id: this.projectId,
            deploy_version_id: "0",
            stage: (eGameStage.Dev as any)
        })
            .then((res) => {
                if (this.deployVersion) {
                    const versions = this.$store.getters.versions(this.projectId);
                    const preVersion = _.find(
                        versions,
                        (v) => v.number === this.deployVersion.number
                    );
                    preVersion.state = "passed";
                    const project = this.$store.getters.project(this.projectId);
                    project.deploy_version_id = null;
                }

                this.toast.clear();
                this.toast.successToast(`${this.$t('deployVersion.version')}`)

                this.$router.replace(`/${this.$i18n.locale}/versionManage/${this.projectId}`);
            })
            .catch((err) => {
                console.error("error",err);
            })


    }

    changeStage() {
        const versions = this.$store.getters.versions(this.projectId);
        const version = _.find(
            versions,
            (v) => v.version === this.selectVersion
        );
        const deploy_version_id = version.id;

        const option: any = {
            id: this.projectId,
            stage: this.selectedStage,
            deploy_version_id
        };

        this.$api.updateProject(option)
            .then((res) => {
                this.$store.dispatch('project', this.projectId)
                this.toast.successToast(`${this.$t('deployManage.update.done')}`); // "업데이트 되었습니다."
                this.$router.push(`/${this.$i18n.locale}/versionManage/${this.projectId}`)
            })
            .catch((err) => {

            })
            .finally(() => {
                this.$modal.hide('selectStageModal')
            })
    }

    hasDeployFile(versions: any) {
        const hasDeployFile = _.filter(versions, (version) => {
            return version.state === 'deploy';
        })

        return hasDeployFile.length === 0 ? false : true;

    }

}
